import React, { useEffect, useState } from "react";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core/";
import { Divider } from "@mui/material";
import { CardBody } from "reactstrap";
import { Tab } from "semantic-ui-react";
import ListItemsTitle from "./listItemTitle";
import ItemSummary from "./itemSummary";
import ListItemEventTab from "./listItemEventTab";

const ListItemTab = ({
  poItems,
  handleExpand,
  handleEditItem,
  handleUpdateStatus,
  parcedPOItem,
  updateItem,
  t,
  error,
  lng,
  rolId,
  disabledUpdate,
  FIELDS_WITHOUT_QUOTES,
  canEditItems,
}) => {
  const [tabActive, setTabActive] = useState([]);

  useEffect(() => {
    setTabActive(poItems.map(() => 0));
  }, []);

  const handleTabChange = (e, { activeIndex }, index) => {
    const newTabActive = [...tabActive];
    newTabActive[index] = activeIndex === 1 ? 1 : 0;
    setTabActive(newTabActive);
  };

  if (!poItems || error) return null;
  return poItems
    .sort((a, b) => b.POItemsId - a.POItemsId)
    .map((item, index) => (
      <React.Fragment key={`${item.LineID}-${index}-fragment`}>
        <ExpansionPanel
          key={`${item.LineID}-${index}-exp`}
          elevation={0}
          defaultExpanded={false}
          expanded={item.expanded}
        >
          <ExpansionPanelSummary>
            <ListItemsTitle
              item={item}
              index={index}
              handleExpand={handleExpand}
              handleEditItem={handleEditItem}
              handleUpdateStatus={handleUpdateStatus}
              parcedPOItem={parcedPOItem}
              rolId={rolId}
              canEditItems={canEditItems}
            />
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <CardBody>
              <Tab
                menu={{
                  secondary: true,
                  pointing: true,
                  className: "custom-tab-menu",
                }}
                activeIndex={tabActive[index]}
                onTabChange={(e, { activeIndex }) =>
                  handleTabChange(e, { activeIndex }, index)
                }
                panes={[
                  {
                    menuItem: t("summary"),
                    render: () => (
                      <ItemSummary
                        item={item}
                        index={index}
                        handleEditItem={handleEditItem}
                        update={updateItem}
                        isEdit={item.edit}
                        lng={lng}
                        disabledUpdate={disabledUpdate}
                        FIELDS_WITHOUT_QUOTES={FIELDS_WITHOUT_QUOTES}
                      />
                    ),
                  },
                  {
                    menuItem: t("events"),
                    render: () => <ListItemEventTab item={item} />,
                  },
                ]}
              />
            </CardBody>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <Divider key={`${item.LineID}-${index}-divider`} />
      </React.Fragment>
    ));
};

export default ListItemTab;
